// Blog block schema - Display published blog posts
export const blogSchema = {
  type: 'blog',
  label: 'Blog',
  description: 'Display your published blog posts',
  icon: 'Newspaper',
  defaultContent: {
    heading: 'Latest Posts',
    maxPosts: 3,
    showViewAll: true,
    style: {},
  },
  fields: [
    { name: 'heading', label: 'Heading', type: 'text', placeholder: 'Latest Posts' },
    { name: 'maxPosts', label: 'Max Posts', type: 'number' },
  ],
};
